<section class="w3l-form-25">
  <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>Pharmatheutical Records Reports</h1>
          <p>Choose Report from pharmatheutical Records Report list </p>
      </div>
  </div>
</section>


<div id="w3l-appointment">
<section class="appointment-section section-gap">
  <div class="wrapper">
      <div class="d-grid doctor-appointment">
          <div class="appointment-form">
              <form action="#" method="post">
                  <div class="fields-grid">
                    <div class="styled-input">
<!-- *************************** -->
<mat-chip-list >
  <a    (click)="openDialog_0()" style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-file-text" style='color:rgb(255, 255, 255)'></i>  {{'1. Patient preparation order by patient' | translate }}</mat-chip></a>
</mat-chip-list>
<mat-chip-list >
  <a    (click)="openDialog_1()" style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-file-text" style='color:rgb(255, 255, 255)'></i>  {{'2. Patients preparation orders from date to date' | translate }}</mat-chip></a>
</mat-chip-list>
<mat-chip-list >
  <a    (click)="openDialog_2()" style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-file-text" style='color:rgb(255, 255, 255)'></i>  {{'3. Drug circulation report by protocols' | translate }}</mat-chip></a>
</mat-chip-list>
<mat-chip-list >
  <a    (click)="openDialog_11()" style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-file-text" style='color:rgb(255, 255, 255)'></i>  {{'4. Saving Drugs By Patient From Date To Date (Detailed) ' | translate }}</mat-chip></a>
</mat-chip-list>
<mat-chip-list >
  <a    (click)="openDialog_00()" style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-file-text" style='color:rgb(255, 255, 255)'></i>  {{'5. Saving Drugs By Patient From Date To Date' | translate }}</mat-chip></a>
</mat-chip-list>

<mat-chip-list >
  <a    (click)="openDialog_10()" style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-file-text" style='color:rgb(255, 255, 255)'></i>  {{'6. Saving Drugs By Item From Date To Date' | translate }}</mat-chip></a>
</mat-chip-list>
<mat-chip-list >
  <a    (click)="ReportItems()" style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-file-text" style='color:rgb(255, 255, 255)'></i>  {{'7. Print drugs master data' | translate }}</mat-chip></a>
</mat-chip-list>
<mat-chip-list >
  <a    (click)="ReportProtocols()" style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-file-text" style='color:rgb(255, 255, 255)'></i>  {{'8. Print protocols master data' | translate }}</mat-chip></a>
</mat-chip-list>
<mat-chip-list >
  <a    href="Home" style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-home" style='color:rgb(255, 255, 255)'></i>  {{'Home' | translate }}</mat-chip></a>
</mat-chip-list>
 <!-- ************************** -->

                    </div>
                  </div>
              </form>
          </div>

          <div class="registerimg">
              <img src="assets/images/report2.jpg" alt="" />
          </div>
      </div>
      <div class="clear"> </div>
  </div>
</section>
</div>


